import { BaseService } from './BaseService';

export class PostsService extends BaseService {
  async getAllPosts(): Promise<any> {
    return this.get('/posts');
  }

  async getPostById(id: string | number): Promise<any> {
    return this.get(`/posts/${id}`);
  }
}

export default new PostsService();
